import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  CashAccountModel,
  CashAccountMutationInput,
  CashAccountDeleteInput,
  CashAccountUpdateInput,
} from './model';

export function useCreateCashAccount(
  options?: UseMutationOptions<
    ApiResult<CashAccountModel>,
    ApiError,
    CashAccountMutationInput
  >,
): UseMutationResult<
  ApiResult<CashAccountModel>,
  ApiError,
  CashAccountMutationInput
> {
  return useMutation<
    ApiResult<CashAccountModel>,
    ApiError,
    CashAccountMutationInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: 'cash-accounts',
      method: 'POST',
      classType: CashAccountModel,
      body,
    });
  }, options);
}

export function useUpdateCashAccount(
  options?: UseMutationOptions<
    ApiResult<CashAccountModel>,
    ApiError,
    CashAccountUpdateInput
  >,
): UseMutationResult<
  ApiResult<CashAccountModel>,
  ApiError,
  CashAccountUpdateInput
> {
  return useMutation<
    ApiResult<CashAccountModel>,
    ApiError,
    CashAccountUpdateInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `cash-accounts/${body.cashAccountId}`,
      method: 'PUT',
      classType: CashAccountModel,
      body: body.body,
    });
  }, options);
}

export function useDeleteCashAccount(
  options?: UseMutationOptions<
    { message: string },
    ApiError,
    CashAccountDeleteInput
  >,
): UseMutationResult<{ message: string }, ApiError, CashAccountDeleteInput> {
  return useMutation<{ message: string }, ApiError, CashAccountDeleteInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `cash-accounts/${body.cashAccountId}`,
        method: 'DELETE',
      });
    },
    options,
  );
}
